module.exports = __webpack_public_path__ + "static/media/Folder.ef16da4e.svg";